var joinDiscussion = window.joinDiscussion;
var joinDiscussion;
joinDiscussion = function ($target) {
  $target.button("loading");
  return $.ajax({
    type: 'POST',
    url: $r.api_v0_discussion_audience_invitations_path({
      subdomain_param: "api",
      discussion_id: $target.data("invitation-id")
    })
  }).done(function () {
    return window.location.replace($target.data('discussion-url'));
  }).fail(function () {
    alert("Failure joining discussion.");
    return $target.button("reset");
  });
};
$(document).on('click', '.js-notification-join-button', function (e) {
  e.preventDefault();
  return joinDiscussion($(e.currentTarget));
});
window.joinDiscussion = joinDiscussion;